import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// "An admin without permission sees neither 'All countries' nor System and
// cannot open either via URL" — this covers the "via URL" half for System
// on the frontend. The underlying data stays protected either way: every
// System page's own API calls (staff, logs) already require manage_staff /
// view_logs server-side, same as before this restructure.
const RequireOwnerOrAdmin = ({ children }) => {
  const { adminRole } = useAuth();
  if (adminRole && !['company_director', 'super_admin'].includes(adminRole.role_type)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export default RequireOwnerOrAdmin;
